// Every English string on the kitchen-basics screen (Stage 2D), in one place.
export const BT = {
  tab: 'Basics',
  storeTab: 'Kitchen basics',
  title: 'Kitchen basics',
  help: 'Salt, oil, flour, spices — what the kitchen should always hold.',
  lowTitle: (n: number) => (n === 0 ? 'Nothing is running low.' : `${n} running low`),
  colItem: 'Item',
  colKitchen: 'Kitchen has',
  colMin: 'Least',
  colWay: 'On the way',
  colStore: 'Store has',
  colSend: 'Send',
  askAll: 'Ask the store for all of it',
  pushAll: 'Send to the kitchen now',
  asked: (no: string) => `Asked the store — ${no}`,
  pushed: (no: string) => `Sent to the kitchen — ${no}. The kitchen confirms when it arrives.`,
  low: 'low',
  ok: 'OK',
  setup: 'Choose the basics',
  setupHelp: 'Pick an item and set the least the kitchen should hold (and the most, if you like).',
  search: 'Search items…',
  min: 'Least',
  max: 'Most (optional)',
  add: 'Make it a basic',
  remove: 'Not a basic',
  saved: 'Saved',
  none: 'No basics yet.',
} as const
